<template>
  <div class="asset-association-modal">
    <div
      v-if="asset"
      class="modal"
      :class="{media: assetType === 'Attachment', exhibit: assetType === 'Grouping'}"
    >
      <div
        class="close"
        @click="$emit('close-button-clicked')"
      >
        <icon
          name="cross"
          :variant="assetType === 'Grouping' ? 'white' : null"
        />
      </div>
      <template v-if="assetType === 'Topic'">
        <topic-asset-association :asset-association="assetAssociation" />
      </template>
      <template v-else-if="assetType === 'Attachment'">
        <media-attachment
          :attachment="asset"
          :resource="{ id: assetAssociation.assetAId, type: assetAssociation.assetAType }"
        />
      </template>
      <template v-else-if="assetType === 'Grouping'">
        <exhibit :grouping="asset" />
      </template>
    </div>
    <loading
      v-else
    />
  </div>
</template>

<script>
import Exhibit from '@components/singletons/exhibit';
import Icon from '@components/singletons/icon';
import Loading from '@components/singletons/loading';
import TopicAssetAssociation from '@components/assetAssociations/types/topic';
import MediaAttachment from '@components/singletons/mediaAttachment';

export default {
  components: { Exhibit, Loading, MediaAttachment, Icon, TopicAssetAssociation },
  props: {
    assetAssociation: {
      type: Object,
    },
  },
  emits: ['close-button-clicked'],
  computed: {
    asset() {
      if (this.assetAssociation) {
        const id = this.assetAssociation.assetBId;

        switch (this.assetType) {
          case 'Topic':
            return this.$store.getters['topics/topics'][id];
          case 'Attachment':
            return this.$store.getters['attachments/get'][id];
          case 'Grouping':
            return this.$store.getters['groupings/all'][id];
          case 'V3Flashcard':
            return;
        }
      }
    },
    assetType() {
      if (this.assetAssociation) {
        return this.assetAssociation.assetBType;
      }
    },
  },
  mounted() {
    // Attachments are sent with the app payload so the only fetching we should need to do
    // is if the asset is a topic and doesn't already exist in the store
    if (!this.asset || this.assetAssociation.assetBType === 'Grouping') {
      this.$store.dispatch('assetAssociations/assets', { assetAssociationIds: [this.assetAssociation.id] });
    }
  },
};
</script>

<style lang='scss' scoped>
.asset-association-modal {
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all 300ms linear;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .modal {
    overflow-y: auto;
    width: 70%;
    height: 70%;
    max-height: 90vh;
    background-color: white;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.22);
    border-top: 2px #00d0dc solid;
    transition: all 300ms linear;
    position: relative;

    &.exhibit {
      border-top: none;
      overflow: hidden;

      .close {
        right: rem-calc(20);
        top: rem-calc(20);
      }
    }

    @include breakpoint(small) {
      height: 100%;
      width: 100%;
    }

    .close {
      cursor: pointer;
      height: rem-calc(24);
      width: rem-calc(24);
      position: absolute;
      right: 12px;
      top: 12px;
      opacity: 0.4;

      &:hover {
        opacity: 0.7;
      }
    }

    &.media {
      right: 0px;
      top: 0px;
      height: auto;
      width: 50%;
      max-width: rem-calc(800);
      padding: rem-calc(8) rem-calc(48) rem-calc(48);

      @include breakpoint(medium) {
        width: 70%;
        padding: rem-calc(8) rem-calc(32) rem-calc(32);
      }

      @include breakpoint(small) {
        width: 90%;
        padding: rem-calc(8) rem-calc(12) rem-calc(12);
      }
    }

    .attachment-name {
      text-align: center;
      font-weight: $semi-bold;
      margin-bottom: 0;
      margin-top: rem-calc(32);

      @include breakpoint(small) {
        margin-top: rem-calc(24);
      }

      @include breakpoint(small) {
        margin-top: rem-calc(16);
      }
    }

    .media-attachment-container {
      margin: rem-calc(24);
    }
  }
}
</style>
